import { usePaginatedApi } from "../../../swr/useApi";
import { adminPaymentsService } from "../data/admin-payments.service";
import type { ListPaymentsQueryDto, PaymentDto } from "../data/types";

export function useAdminPayments(query?: ListPaymentsQueryDto) {
  return usePaginatedApi<PaymentDto, ListPaymentsQueryDto>({
    key: "admin-payments",
    serviceMethod: async (queryParams) =>
      await adminPaymentsService.listPayments(queryParams),
    query: query,
  });
}
